import { Injectable } from '@angular/core';
import { WebService } from './../service/web.service'
import { AppGlobals } from './../service/app.global';

@Injectable()
export class ProfileService 
{
    constructor(public webService: WebService) { }

    update(data) 
    {
        return this.webService.Put(data,'UserMasterAPI/UpdateUserProfile');
    }

    getbyid(id) 
    {
        return this.webService.Get('UserMasterAPI/GetById?UserId='+id+'');
    }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.service.ts